import RegistrationModel from 'models/users/registrationModel';
import UserResource from 'models/users/resource';
import React from 'react';

interface AccessDef {
  registerUser: (binding: RegistrationModel) => Promise<void>;
  deleteUser: (user: UserResource) => Promise<void>;
}
export const Context = React.createContext<AccessDef>({
  registerUser: async () => undefined,
  deleteUser: async () => undefined,
});

export default Context;

export interface SelectionValue {
  deleting?: UserResource;

}

export interface SelectionContextValue {
  selection: SelectionValue;
  setSelection: (value: SelectionValue) => void;
}

export const SelectionContext = React.createContext<SelectionContextValue>({
  selection: {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setSelection: () => {},
});
